import { Component, OnInit, HostBinding, Input } from '@angular/core';
import { FilterControl } from '../../../interfaces/filter-control';
import { FilterControlParams } from '../../../interfaces/filter-control-params';

@Component({
  selector: 'bm-boolean-filter',
  templateUrl: './boolean-filter.component.html',
  styleUrls: ['./boolean-filter.component.scss']
})
export class BooleanFilterComponent implements FilterControl , OnInit {

  @HostBinding('class')
  @Input() className = '';

  @Input() control: FilterControlParams;

  options = [{
    name: 'All',
    value: 'all'
  }, {
    name: 'Yes',
    value: true
  }, {
    name: 'No',
    value: false,
  }];

  constructor() {
  }

  @HostBinding('className')
  get class() {
    return 'col-md-3';
  }

  ngOnInit() {

    if (this.control.value === null) {
      this.control.compactValue = 'all';
      this.control.value = null;
    } else {
      this.control.compactValue = this.control.value;
    }
  }

  onChange(option) {
    if (typeof option.value === 'boolean') {
      this.control.value = option.value;
    } else {
      this.control.value = null;
    }
  }

}
